import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@chakra-ui/react';
import { FormField, FormInput, } from '@client/components/input/FormField';
import { DayRangeInput, validateDayRange, } from '@client/components/listingForm/DayRangeInput';
import { AppDialog } from '@client/components/misc/AppDialog';
import { DialogConfirmFooter } from '@client/components/misc/DialogConfirmFooter';
import { validateProcessingProfileInput } from '@heirloom/common/validation/profiles';
import { ValidationField, } from '@heirloom/common/validation/shared';
import { useEffect, useState } from 'react';
export const ProcessingProfileDialog = ({ open, onClose, onConfirm, existingNames = [], saving = false, }) => {
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState(null);
    const [minDays, setMinDays] = useState('');
    const [maxDays, setMaxDays] = useState('');
    const [daysError, setDaysError] = useState(null);
    useEffect(() => {
        if (!open) {
            setName('');
            setMinDays('');
            setMaxDays('');
            setNameError(null);
            setDaysError(null);
        }
    }, [open]);
    const isDirty = () => !!name || !!minDays || !!maxDays;
    const handleClose = () => {
        if (isDirty()) {
            if (!window.confirm('Discard changes?'))
                return;
        }
        onClose();
    };
    const handleConfirm = () => {
        const errors = validateProcessingProfileInput({
            name,
            existingNames,
            minDays,
            maxDays,
        });
        const findError = (field) => errors.find((e) => e.field === field)?.message ?? null;
        setNameError(findError(ValidationField.Name));
        setDaysError(findError(ValidationField.Days));
        if (errors.length > 0)
            return;
        const days = validateDayRange(minDays, maxDays);
        void onConfirm({
            name: name.trim(),
            minDays: days.min,
            maxDays: days.max,
        });
    };
    return (_jsx(AppDialog, { title: "New Processing Profile", open: open, onCancel: handleClose, pending: saving, size: "xs", footer: _jsx(DialogConfirmFooter, { onCancel: handleClose, onConfirm: handleConfirm, confirmLabel: "Create", pending: saving }), children: _jsxs(Stack, { gap: 4, children: [_jsx(FormField, { label: "Name", error: nameError, required: true, children: _jsx(FormInput, { value: name, onChange: (e) => {
                            setName(e.target.value);
                            if (e.target.value.trim())
                                setNameError(null);
                        }, placeholder: "e.g. Default", disabled: saving }) }), _jsx(FormField, { label: "Lead Time", error: daysError, required: true, children: _jsx(DayRangeInput, { minDays: minDays, maxDays: maxDays, onChangeMin: (v) => {
                            setMinDays(v);
                            setDaysError(null);
                        }, onChangeMax: (v) => {
                            setMaxDays(v);
                            setDaysError(null);
                        }, disabled: saving }) })] }) }));
};
